/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Bwf_Description_LabelInputs */

const en_audio_description_export_bwf_description_label = /** @type {(inputs: Audio_Description_Export_Bwf_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const fr_audio_description_export_bwf_description_label = /** @type {(inputs: Audio_Description_Export_Bwf_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_audio_description_export_bwf_description_label = /** @type {(inputs: Audio_Description_Export_Bwf_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

const it_audio_description_export_bwf_description_label = /** @type {(inputs: Audio_Description_Export_Bwf_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione`)
};

const ru_audio_description_export_bwf_description_label = /** @type {(inputs: Audio_Description_Export_Bwf_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание`)
};

const es_audio_description_export_bwf_description_label = /** @type {(inputs: Audio_Description_Export_Bwf_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción`)
};

const zh_cn2_audio_description_export_bwf_description_label = /** @type {(inputs: Audio_Description_Export_Bwf_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述`)
};

const ja_audio_description_export_bwf_description_label = /** @type {(inputs: Audio_Description_Export_Bwf_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明`)
};

const hi_audio_description_export_bwf_description_label = /** @type {(inputs: Audio_Description_Export_Bwf_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विवरण`)
};

const pt_pt2_audio_description_export_bwf_description_label = /** @type {(inputs: Audio_Description_Export_Bwf_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Audio_Description_Export_Bwf_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_bwf_description_label = /** @type {((inputs?: Audio_Description_Export_Bwf_Description_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Bwf_Description_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_bwf_description_label(inputs)
	if (locale === "de") return de_audio_description_export_bwf_description_label(inputs)
	if (locale === "it") return it_audio_description_export_bwf_description_label(inputs)
	if (locale === "ru") return ru_audio_description_export_bwf_description_label(inputs)
	if (locale === "es") return es_audio_description_export_bwf_description_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_bwf_description_label(inputs)
	if (locale === "ja") return ja_audio_description_export_bwf_description_label(inputs)
	if (locale === "hi") return hi_audio_description_export_bwf_description_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_bwf_description_label(inputs)
	return en_audio_description_export_bwf_description_label(inputs)
});